import { Namespace, useT } from "@racoon/i18n";
import { DateRangePicker } from "@racoon/ui";
import { cn } from "@racoon/ui";

export const getThisWeekDates = () => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const weekStart = new Date(today);
  weekStart.setDate(today.getDate() - daysToMonday); // Monday
  weekStart.setHours(0, 0, 0, 0);

  const weekEnd = new Date(today);
  weekEnd.setHours(23, 59, 59, 999);

  return { weekStart, weekEnd };
};

export const getLastSevenDaysDates = () => {
  const today = new Date();

  const rangeStart = new Date(today);
  rangeStart.setDate(today.getDate() - 6);
  rangeStart.setHours(0, 0, 0, 0);

  const rangeEnd = new Date(today);
  rangeEnd.setHours(23, 59, 59, 999);

  return { weekStart: rangeStart, weekEnd: rangeEnd };
};

export const DateView = ({
  weekStart,
  weekEnd,
  containerClassName,
  onDateChange,
}: {
  weekStart: Date;
  weekEnd: Date;
  containerClassName?: string;
  onDateChange?: (from: Date, to: Date) => void;
}) => {
  const t = useT();

  return (
    <div className={cn("flex-shrink-0 p-4 flex items-center justify-between", containerClassName)}>
      <p className="text-sm font-medium text-slate-900">{t(Namespace.Govdash, "forPeriod")}</p>
      <DateRangePicker
        initialDateFrom={weekStart}
        initialDateTo={weekEnd}
        showPresets={true}
        onUpdate={(values: any) => {
          if (onDateChange && values.range?.from && values.range?.to) {
            onDateChange(values.range.from, values.range.to);
          }
        }}
      />
    </div>
  );
};
